import React, { useState, useEffect } from 'react';
import { Layout as AntLayout, FloatButton, BackTop } from 'antd';
import { useLocation } from 'react-router-dom';
import Header from './Header';
import Sidebar from './Sidebar';
import BreadcrumbNav from './BreadcrumbNav';
import PageTransition from './PageTransition';
import { useTheme } from '../context/ThemeContext';
import { VerticalAlignTopOutlined } from '@ant-design/icons';
import { findMenuByPath, menuItems } from '../menuConfig';

const { Content } = AntLayout;

const Layout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const location = useLocation();
  const [collapsed, setCollapsed] = useState(false);
  const { isDark } = useTheme();

  // 订单详情页/编辑页自动收起侧边栏，获得更大展示区域
  useEffect(() => {
    const isOrderDetail = /^\/orders\/\d+(\/edit)?$/.test(location.pathname);
    setCollapsed(isOrderDetail);
  }, [location.pathname]);

  // 根据当前路径设置浏览器标签标题为二级菜单名称
  useEffect(() => {
    const menu = findMenuByPath(menuItems, location.pathname);
    const pageName = menu?.label || '';
    document.title = pageName ? `${pageName} - JDSUIT AGI` : 'JDSUIT AGI';
  }, [location.pathname]);

  return (
    <AntLayout style={{ minHeight: '100vh', background: isDark ? '#000' : '#f0f2f5' }}>
      <Sidebar collapsed={collapsed} onCollapse={setCollapsed} />
      <AntLayout
        style={{
          marginLeft: collapsed ? 64 : 200,
          transition: 'margin-left 0.25s cubic-bezier(0.4, 0, 0.2, 1)',
          minHeight: '100vh',
          '--sidebar-width': collapsed ? '64px' : '200px',
        } as React.CSSProperties}
      >
        <Header />
        <Content style={{ padding: '16px 24px 24px', width: '100%' }}>
          <BreadcrumbNav />
          <PageTransition key={window.location.pathname}>
            {children}
          </PageTransition>
        </Content>
        <BackTop style={{ right: 24, bottom: 24 }}>
          <FloatButton
            icon={<VerticalAlignTopOutlined />}
            style={{
              width: 40,
              height: 40,
              borderRadius: '50%',
              boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
            }}
          />
        </BackTop>
      </AntLayout>
    </AntLayout>
  );
};

export default Layout;
